module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'problemOrder',
      "lazy": true
    },
    on: {
      "hidden": _vm.hideProblemModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Сообщить о проблеме с заказом № " + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сообщаем о проблеме..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.problem($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.$v.text.$error
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "cancel-input"
    }
  }, [_vm._v("Описание проблемы")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "focusThis",
    staticClass: "form-control",
    attrs: {
      "id": "cancel-input",
      "rows": "4",
      "placeholder": "Подробно опишите почему этот заказ проблемный, например: 'Клиент не приехал в назначенное время', 'Нет оборудования', 'Все занято не можем принять' и т.д."
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }, function($event) {
        _vm.$v.text.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.text.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Пожалуйста опишите проблему")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideProblemModal($event)
      }
    }
  }, [_vm._v("Ничего не делать")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: {
      'disabled': _vm.$v.text.$invalid
    },
    attrs: {
      "variant": "warning",
      "disabled": _vm.$v.text.$invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.problem($event)
      }
    }
  }, [_vm._v("Сообщить о проблеме")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16d25d92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-16d25d92"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalProblemOrder.vue
// module id = 1000
// module chunks = 1